import gql from 'graphql-tag'

export default gql`mutation go($startDate: String, $endDate: String, $officeId: Int){
  exportScheduler(startDate: $startDate, endDate: $endDate, officeId: $officeId)
}`